import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import apiClient, { formatApiErrorDetail } from "@/lib/apiClient";
import { Ship, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    setLoading(true);
    try {
      await apiClient.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated — sign in with your new password.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 wave-bg">
      <div className="absolute top-8 left-8">
        <Link to="/" className="flex items-center gap-2">
          <div className="h-10 w-10 bg-orange border-2 border-ink rounded-2xl flex items-center justify-center shadow-nb-sm"><Ship className="h-5 w-5 text-white" /></div>
          <span className="font-display font-700 text-2xl tracking-tight">Tugboat</span>
        </Link>
      </div>
      <div className="max-w-md w-full nb-card p-8" data-testid="reset-password-page">
        <h1 className="font-display text-4xl font-700 tracking-tight mb-2">Set a new password</h1>
        <p className="text-ink/60 mb-7">Choose a strong password (at least 8 characters).</p>
        {!token ? (
          <p className="text-danger font-700 text-sm">This reset link is missing its token. Please use the link from your email.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="reset-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="nb-input" placeholder="New password" />
            <button data-testid="reset-submit" type="submit" disabled={loading}
              className="nb-btn w-full bg-orange text-white py-3.5 text-sm disabled:opacity-60">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
